import { render, staticRenderFns } from "./PasswordChangeView.vue?vue&type=template&id=42d97e32"
import script from "./PasswordChangeView.vue?vue&type=script&lang=js"
export * from "./PasswordChangeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports